<ng-template
  #mobileNavigationSideSheet="SideSheetDirective"
  uiSideSheetSide="left"
  width="clamp(220px, 80vw, 360px)"
>
  <ui-lekkerland-mobile-navigation
    (closeNavigation)="mobileNavigationSideSheet.close()"
  ></ui-lekkerland-mobile-navigation>
</ng-template>

<ui-lekkerland-header
  [config]="config()"
  (openNavigation)="mobileNavigationSideSheet.open()"
></ui-lekkerland-header>
